import Vue from 'vue';
import Vuex from 'vuex';

import CAR from './modules/car';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    namespaced: true,
    CAR,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js